import { createFileRoute, redirect, Outlet, useRouter } from '@tanstack/react-router';
import { useAuth } from '@/context/AuthContext';
import Navbar from '@/components/NavBar';
import NavMobile from '@/components/Nav-Mobile';
import { useState, useEffect, memo } from 'react';

// Declarar el componente antes de usarlo en Route
const AuthenticatedLayout = memo(() => {
  const [collapsed, setCollapsed] = useState(false);
  const auth = useAuth();
  const router = useRouter();

  // Redirigir si pierde autenticación durante la sesión
  useEffect(() => {
    if (!auth.isAuthenticated && !auth.loading) {
      router.navigate({ to: '/login', replace: true });
    }
  }, [auth.isAuthenticated, auth.loading, router]);

  const mainClassName = `flex-1 p-6 font-outfit text-zinc-900 dark:text-white transition-all duration-300 pb-24 lg:pb-4 ${collapsed ? 'lg:ml-28' : 'lg:ml-70'}`;

  return (
    <>
      <Navbar collapsed={collapsed} setCollapsed={setCollapsed} />
      <NavMobile />
      <main className={mainClassName}>
        <Outlet />

      </main>
    </>
  );
});

AuthenticatedLayout.displayName = 'AuthenticatedLayout';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context, location }) => {
    const { auth } = context;

    // Redirigir inmediatamente si no está autenticado
    if (!auth.isAuthenticated && !auth.loading) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      });
    }

    // Esperar a que termine la carga de autenticación
    if (auth.loading) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }

    // Verificar nuevamente después de esperar
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '.',  //cambiar a /login   (para mas seguridad pero menos user experience)
        // search: { redirect: location.href },   (esta duplicando la ruta en la url del navegador)
      });
    }

    return {
      user: auth.user,
      userRoles: auth.userRoles
    };
  },
  component: AuthenticatedLayout,
});
